import React from 'react';
import { Box, Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import { SettingSidebar } from '../components/setting-sidebar';
import { SettingBreadcrumbs } from '../components/setting-breadcrumbs';
import { SettingTemporarySidebar } from '../components/setting-temporary-sidebar';

const useTheme = makeStyles((theme) => {
  return {
    setting: {
      [theme.breakpoints.up('768')]: {
        display: 'flex',
      },
    },
    sideBar: {
      width: 'max-content',
      minWidth: 280,
      flexShrink: 0,
      [theme.breakpoints.down('768')]: {
        display: 'none',
      },
    },
    tabBar: {
      [theme.breakpoints.up('768')]: {
        display: 'none',
      },
    },
    childBox: {
      flex: 1,
      margin: '24px 0px 24px 16px',
    },
    header: {
      margin: '35px 0px 35px 16px',
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('768')]: {
        margin: '35px 0px 35px 0px',
      },
    },
    title: {
      [theme.breakpoints.down('768')]: {
        display: 'none',
      },
    },
  };
});


const menuItems = {
  profile: [
    {
      text: 'Personal Information',
      path: '/account/profile',
      index: 0,
    },
    {
      text: 'Connections',
      path: '/account/social-account',
      index: 3,
    },
    {
      text: 'Your Current Location',
      path: '/account/location',
      index: 4,
    },
    {
      text: 'Time Zone',
      path: '/account/timezone',
      index: 5,
    },
  ],

  preferences: [
    {
      text: 'Prefered Meeting Times',
      path: '/account/prefer-time',
      index: 1,
    },
    {
      text: 'Prefered Meeting Locaitons',
      path: `/account/prefer-location`,
      index: 2,
    },
  ],

  security: [
    {
      text: 'Change Password',
      path: '/account/change-password',
      index: 6,
    },
  ],
};

export const Setting = ({ children }) => {
  const classes = useTheme();
  return (
    <Box>
      <Box className={classes.header}>
        <Box className={classes.tabBar}>
          <SettingTemporarySidebar menuItems={menuItems} />
        </Box>

        <Typography variant='h5' className={classes.title}>
          Account Settings
        </Typography>

        <Box className={classes.tabBar}>
          <SettingBreadcrumbs />
        </Box>
      </Box>

      <Divider light />

      <Box className={classes.setting}>
        <Box className={classes.sideBar}>
          <SettingSidebar menuItems={menuItems} />
        </Box>

        <Box className={classes.childBox}>{children}</Box>
      </Box>
    </Box>
  );
};
